<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Quantidade de Espigas na Caixa
                </mat-label>
                <input matInput id="txtQntEspigaCaixa" #txtQntEspigaCaixa maxlength="3"
                  formControlName="qnt_espiga_caixa" (blur)="calcEspigaAtipicas()">
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtQntEspigaCaixa.value.length}} / 3</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.espiga_atipica)}}
                  </mat-error>  -->
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espigas Atipicas
                </mat-label>
                <input matInput id="txtEspigaAtipica" #txtEspigaAtipica maxlength="3" formControlName="espiga_atipica"
                  (blur)="calcEspigaAtipicas()">
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtEspigaAtipica.value.length}} / 3</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.espiga_atipica)}}
                  </mat-error>  -->
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Inicio linha 2 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">(%) de Espigas Atipicas
                </mat-label>
                <input matInput id="txtCalcIV" #txtCalcIV maxlength="10" formControlName="prc_espiga_atipica" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcIV.value.length}} / 10</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.prc_espiga_atipica)}}
                  </mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espigas Morte Prematura
                </mat-label>
                <input matInput id="txtCalcV" #txtCalcV maxlength="3" formControlName="morte_prematura"
                  (blur)="calcMortePrematura()">
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcV.value.length}} / 3</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.morte_prematura)}}
                  </mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">(%) de Morte Prematura
                </mat-label>
                <input matInput id="txtCalcVI" #txtCalcVI maxlength="10" formControlName="prc_morte_prematura" readonly
                  currencyMask class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCalcVI.value.length}} / 10</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.prc_morte_prematura)}}
                  </mat-error> -->
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>